
import { useResourceUsage } from './use-resource-usage';
import { useSubscriptionData } from './use-subscription-data';
import { useAuth } from '@/contexts/AuthContext';

export const usePremiumBotAccountValidation = () => {
  const { user } = useAuth();
  const { data: subscriptionData } = useSubscriptionData(user?.id);
  const { data: resourceUsage } = useResourceUsage(user?.id);

  const canAddAccount = () => {
    if (!subscriptionData?.package || !resourceUsage) {
      return false;
    }
    return resourceUsage.premiumBotAccountsCount < subscriptionData.package.max_premium_bots;
  };

  const getErrorMessage = () => {
    if (!subscriptionData?.package) {
      return 'No active subscription found. Please upgrade to connect trading accounts.';
    }
    if (resourceUsage && resourceUsage.premiumBotAccountsCount >= subscriptionData.package.max_premium_bots) {
      return `You've reached your limit of ${subscriptionData.package.max_premium_bots} premium bot connections. Please upgrade your subscription to add more accounts.`;
    }
    return null;
  };

  return {
    canAddAccount,
    getErrorMessage,
    currentCount: resourceUsage?.premiumBotAccountsCount || 0,
    maxAccounts: subscriptionData?.package?.max_premium_bots || 0
  };
};
